import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Collapse, Icon, message } from 'antd';
import { MyIcon } from '../../common/baseConfig';
import * as actions from './redux/actions';
import LoginModal from "../common/LoginModal"
const Panel = Collapse.Panel;
export class CourseCatalog extends Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    visible: false,
    videoArr: [],
  }
  componentWillReceiveProps(nextProps) {
    const { fetchGetCourseChapterSuccess } = nextProps.course;
    let videoArr = []
    if (fetchGetCourseChapterSuccess) {
      fetchGetCourseChapterSuccess.forEach(item => {
        item.ChildNodeList.forEach(it => {
          videoArr.push(it);
        })
      })
      this.setState({ videoArr })
    }
  }
  onCancel() {
    this.setState({
      visible: false,
    })
  }
  checkIsLook(index) {
    const { videoArr } = this.state;

    if (videoArr.length === 0) return;

    const { fetchGetWConfigurationSuccess } = this.props.course;
    if (fetchGetWConfigurationSuccess.OrderView !== 1) {
      //开放所有章节视频
      return true;
    }
    //按顺序播放
    if (index === 0) {
      //第一个课程 直接可跳转
      return true
    } else {
      let lastItem = videoArr[index - 1];
      if (lastItem.IsOpen !== 3) {
        //上个视频不是收费 直接跳转
        return true
      } else {
        if (lastItem.IsLook === 1) {
          //上个视频看完了
          return true
        } else {
          return false;
        }
      }
    }
  }
  getIndex(i, index) {
    const { fetchGetCourseChapterSuccess } = this.props.course;
    if (!fetchGetCourseChapterSuccess) return;
    let Index = 0;
    if (i - 1 < 0) {
      return index;
    } else {
      for (let j = 0; j < fetchGetCourseChapterSuccess.length; j++) {
        let element = fetchGetCourseChapterSuccess[j];
        if (j < i) {
          Index += element.ChildNodeList.length;
        }
      }
      Index = Index + index;
      return Index
    }
  }
  render() {
    const { fetchGetCourseChapterSuccess, fetchGetWConfigurationSuccess } = this.props.course;
    const { IsPay } = this.props
    const { visible } = this.state;
    if (!fetchGetCourseChapterSuccess) return null;
    return (
      <div className="course-course-catalog">
        <Collapse
          accordion
          defaultActiveKey={"1"}
          expandIconPosition={'right'}
          expandIcon={({ isActive }) => (
            <MyIcon
              type="iconxiala2"
              style={{ fontSize: 20, color: '#ddd' }}
              rotate={isActive ? 90 : 0}
            />
          )}
        >
          {fetchGetCourseChapterSuccess.map((ele, i) => (
            <Panel header={ele.Name} key={i + 1}>
              {ele.ChildNodeList.map((item, index) => (
                <div className="catalog-item" key={item.ID} onClick={() => {
                  if (item.IsOpen === 3) {
                    //收费课程
                    if (IsPay === 1) {
                      //已购买

                      if (this.checkIsLook(this.getIndex(i, index))) {
                        this.props.history.push(`/course/video/${item.Course_ID}-${item.ID}-${item.CourseWare_ID}`);
                      } else {
                        //上个没看完
                        message.warn('请观看完上个视频才能解锁本视频')
                      }
                    } else {
                      //收费但是未购买
                      message.warn('该视频未购买不能观看');
                    }
                  } else if (item.IsOpen === 1) {
                    //免费课程
                    if (fetchGetWConfigurationSuccess.UserSeeAuth === 0) {
                      //所有用户可看
                      this.props.history.push(`/course/video/${item.Course_ID}-${item.ID}-${item.CourseWare_ID}`);
                    } else {
                      //注册用户可看
                      if (localStorage.getItem('studentinfo')) {
                        //已经登录
                        this.props.history.push(`/course/video/${item.Course_ID}-${item.ID}-${item.CourseWare_ID}`);
                      } else {
                        message.warn('该免费课程请登录后观看')
                        this.setState({
                          visible: true,
                        })
                      }
                    }
                  } else {
                    //试听课程
                    if (fetchGetWConfigurationSuccess.OverFlowAuth === 0) {
                      //所有用户可看
                      this.props.history.push(`/course/video/${item.Course_ID}-${item.ID}-${item.CourseWare_ID}`);
                    } else {
                      //注册用户可看
                      if (localStorage.getItem('studentinfo')) {
                        //已经登录
                        this.props.history.push(`/course/video/${item.Course_ID}-${item.ID}-${item.CourseWare_ID}`);
                      } else {
                        this.setState({
                          visible: true,
                        })
                        message.warn('该试听课程请登录后观看')
                      }
                    }
                  }
                }}>
                  <p>
                    <Icon type="play-circle" theme="filled" />
                    <span>{item.Name}</span>
                  </p>
                  <p>
                    {
                      item.IsOpen === 1 ? <span className="free">免费</span> : item.IsOpen === 2 ? <span className="try">可试学</span> :
                        IsPay === 0 ? <MyIcon type="iconsuo" /> : this.checkIsLook(this.getIndex(i, index)) ? null : <MyIcon type="iconsuo" />
                    }
                  </p>
                </div>
              ))}
            </Panel>
          ))}
        </Collapse>
        <LoginModal visible={visible} onCancel={this.onCancel.bind(this)} />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CourseCatalog));



// WEBPACK FOOTER //
// ./src/features/course/CourseCatalog.js